import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { Gateway } from 'src/app/storage/models/gateway.model';
import { BehaviorSubject } from 'rxjs';
import { ApiService } from './api.service';
import { IGateway } from 'src/app/storage/interfaces/gateway.interface';

const URL = environment.aws.amplify.API.REST;

@Injectable({
  providedIn: 'root'
})
export class GatewaysService {

  gateways$: BehaviorSubject<Gateway[]> = new BehaviorSubject(null);

  constructor(
    private translateService: TranslateService,
    private apiService: ApiService
  ) { }

  async getGateways(marketname: string, missionId: string): Promise<Gateway[] | null> {
    const translations = await this.translateService.get('GATEWAYS').toPromise();

    const response = await this.apiService.get(
      `${URL}gateways/market/${marketname}/${missionId}`,
      translations['LABEL']
    );

    return response ?
          response.gateways.map((gateway: IGateway) => new Gateway(gateway)) :
          null;
  }
}
